import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import useDismissible from 'ui-forms-components/hooks/useDismissible';
import { GET_PORTAL_ALERT_FLAGS } from './queries';
import { DISPLAY_UNTIL, FIELD_NAME, INVALID_NOTIFICATION_RECIPIENTS } from './constants';
import getShouldNotDisplayByDate from '../getShouldNotDisplayByDate';
const useShouldShowNotificationRecipientBanner = () => {
  const {
    loading,
    error,
    data: flags
  } = useQuery(GET_PORTAL_ALERT_FLAGS);
  const [shouldLocalStorageBeShown, updateLocalStorageKey] = useDismissible('notification-recipient-banner-timestamp', 1);
  const showBanner = useMemo(() => {
    if (!shouldLocalStorageBeShown) {
      return false;
    }
    if (loading || error || !flags) {
      return false;
    }
    if (FIELD_NAME in flags) {
      const {
        portalAlerts
      } = flags.portalAlerts;
      return portalAlerts.includes(INVALID_NOTIFICATION_RECIPIENTS);
    }
    return false;
  }, [loading, error, flags, shouldLocalStorageBeShown]);
  return [showBanner && !getShouldNotDisplayByDate(DISPLAY_UNTIL), updateLocalStorageKey];
};
export default useShouldShowNotificationRecipientBanner;